import {
  AcUnit,
  Tv,
  DoorSliding,
  Desk,
  Bed,
  Balcony,
  HotTub,
  Air,
  Lock,
  Wifi,
  ElectricBolt,
  WaterDrop,
  LocalLaundryService,
  Security,
  TwoWheeler,
  DirectionsCar,
  Elevator,
  FitnessCenter,
  Kitchen,
  HelpOutline,
} from "@mui/icons-material";

const ICON_MAP = {
  // Unit Keys
  ac: AcUnit,
  tv: Tv,
  wardrobe: DoorSliding,
  studyTable: Desk,
  mattress: Bed,
  balcony: Balcony,
  geyser: HotTub,
  fan: Air,
  locker: Lock,
  unitWifi: Wifi,

  // Property Keys
  wifi: Wifi,
  powerBackup: ElectricBolt,
  roWater: WaterDrop,
  laundry: LocalLaundryService,
  cctv: Security,
  parkingBike: TwoWheeler,
  parkingCar: DirectionsCar,
  lift: Elevator,
  gym: FitnessCenter,
  commonTv: Tv,
  fridge: Kitchen,
};

export const AmenityIcon = ({ iconKey, ...props }) => {
  const IconComponent = ICON_MAP[iconKey] || HelpOutline;
  return <IconComponent fontSize="inherit" {...props} />;
};
